module.exports = __webpack_public_path__ + "static/media/6222.fbd6f538.jpg";